import { css } from '@emotion/react';

export const mainContainer = css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const header = css`
    display: flex;
    height: 25px;
    align-items: center;
`;

export const option = css`
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    justify-content: center;
    padding: 4px;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    margin-bottom: 4px;
    transition: all 0.2s ease;

    &:hover {
        background: #f8f9fa;
        border-color: #adb5bd;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
`;

export const swiper = css`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
`;

export const optionName = css`
    font-size: 11px;
    font-family: 'SCDream4';
    color: #495057;
    min-width: 100px;
    padding-left: 12px;
    text-align: start;
    white-space: nowrap;
`;

export const distanceLabel = css`
    font-size: 11px;
    font-family: 'SCDream4';
    color: #495057;
    min-width: 10px;
    text-align: start;
    white-space: nowrap;
`;

export const optionList = (flexDirection) => css`
    display: flex;
    flex-direction: ${flexDirection || 'column'};
    gap: 4px;
    margin: 8px 7;
    padding: 8px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e9ecef;
`;

export const button = css`
    padding: 4px 6px;
    background: #667eea;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 11px;
    font-family: 'SCDream4';
    cursor: pointer;
    transition: all 0.2s ease;
    margin: 0 2px;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const disabled = css`
    background: #6c757d;
    cursor: not-allowed;

    &:hover {
        transform: none;
        box-shadow: none;
    }
`;

export const divider = css`
    width: 100%;
    height: 1px;
    background-color: #e9ecef;
    margin: 8px 0;
`;
